import { Requester } from './Requester';
import { ISurveyFull } from '../types';

export const GetSurveyById = async (surveyId: string): Promise<ISurveyFull | null> => {
    try {
        const response = await Requester<ISurveyFull>({
            path: `surveys/${surveyId}`,
            method: 'GET'
        });

        return Object.hasOwn(response, '_id') ? (response as ISurveyFull) : null;
    } catch (e) {
        console.error('Get survey request failed');
        return Promise.reject(e);
    }
};
